export default "__VITE_ASSET__10c11ce4__"